import React from 'react';
import { Link } from 'react-router-dom';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { isEmptyObject } from 'Utilities/helpers';

import RelatedGuides from '../../contentPages/landingPages/RelatedGuides/RelatedGuides';

import LocalTexts from './SimilarArticlesTexts.json';

import styles from './SimilarArticles.scss';

type Thumbnail = {
  alt?: string;
  url: string;
};

type ContentArea = {
  description: string;
  thumbnail?: string | Thumbnail | null;
  title: string;
  url: string;
};

type SimilarArticlesProps = {
  acf: any;
};

const LocalT = new MDText(LocalTexts);

const SimilarArticles = ({ acf }: SimilarArticlesProps) => {
  if (!acf || isEmptyObject(acf)) {
    return <p className={styles.error}>{LocalT.translate('errorMessage')}</p>;
  }

  const { contentArea, ctaText, ctaUrl, header } = acf;

  return (
    <div className={styles.component}>
      <h2 className={styles.title}>{header || LocalT.translate('title')}</h2>
      <div className={styles.container}>
        {
          contentArea.map(({ description, thumbnail, title, url }: ContentArea, index: number) => (
            <RelatedGuides
              key={`similar-article-${index}`}
              largeTheme
              {...{ description, thumbnail, title, url } }
            />
          ))
        }
        {
          ctaText && ctaUrl
            && <Button
              data-thc-button
              as={Link}
              label={ctaText}
              to={ctaUrl}
              variant='secondary'
            />
        }
      </div>
    </div>
  );
};

export default SimilarArticles;
